import Recruiter from "../../apiResources/Recruiter";
import RecruiterUser from "../../apiResources/RecruiterUser";

export const updateAboutCompany = async ({ aboutCompany, companyId }) => {
  const recruiter = await Recruiter.find(companyId);

  recruiter.data.profile = aboutCompany;

  await recruiter.data.save();

  return recruiter;
};

export const updateAboutMe = async ({ aboutAgent, userId }) => {
  const recruiterUser = await RecruiterUser.find(userId);

  recruiterUser.data.biography = aboutAgent;

  await recruiterUser.data.save();

  return recruiterUser;
};

export const updateCandidateQualifiers = async ({
  userId,
  qualificationTechniques,
}) => {
  const recruiterUser = await RecruiterUser.includes(
    "candidate_qualifier"
  ).find(userId);

  recruiterUser.data.candidateQualifier.list = qualificationTechniques;

  await recruiterUser.data.save({ with: "candidateQualifier" });

  return recruiterUser;
};

export const updateSpecialities = async ({ userId, companySpecialities }) => {
  const recruiterUser = await RecruiterUser.includes("speciality").find(userId);

  recruiterUser.data.speciality.description = companySpecialities;

  await recruiterUser.data.save({ with: "speciality" });

  return recruiterUser;
};

export const updateUser = async ({ user }) => {
  const { id, companyName, ...attributes } = user;
  const recruiterUser = await RecruiterUser.includes("recruiter").find(id);
  const { recruiter } = attributes;

  delete attributes.avatar;
  delete attributes.recruiter;

  recruiterUser.data.assignAttributes(attributes);
  recruiterUser.data.recruiter.assignAttributes(recruiter);

  await recruiterUser.data.save({ with: "recruiter" });

  return recruiterUser;
};

export const updateUserPhoto = async ({ photo, userId }) => {
  const recruiterUser = await RecruiterUser.find(userId);

  recruiterUser.data.photo = photo;

  await recruiterUser.data.save();

  return recruiterUser;
};

export const updateRecruiterProfileImage = async ({ profileImage, userId }) => {
  const recruiterUser = await RecruiterUser.includes("recruiter").find(userId);

  recruiterUser.data.recruiter.profileImage = profileImage;

  await recruiterUser.data.save({ with: "recruiter" });

  return recruiterUser;
};
